/**
 * Created by Tangting on 2017/2/14.
 */
import Vue from 'vue';
import tpl from './tpl.html';
import Loading from '../../../component/Loading.vue';

import Pager from '../../../component/Pager.vue';
import commonService from '../../../common/commonService';
import parseUrl from '../../../util/parseUrl';

export default Vue.extend({
    name: "contractInfo",
    template: tpl,
    components: {
        Loading,
        Pager
    },
    data(){
        return {
            contract_id: parseUrl().contract_id || '', // 合约地址

            addr: '', // 合约地址
            name: '', // 合约名称
            status: '', // 合约状态
            balance: 0, //合约余额
            margin: 0, // 保证金
            regTime: '', // 注册时间
            ownerAddress: '', // 合约所有名称有则显示名称
            ownerName: '', // 合约所有名称
            hash: '', //合约字节码hash
            description: '', //合约描述
            abis: [], //合约函数
            events: [], // 事件

            dealList: [], // 交易列表
            pageNo: 1,
            pageNum: 0,
            pageSize: 10,
        }
    },
    mounted(){
        window.scrollTo(0, 0);
        this.fetchContractInfo();
        this.fetchDealRecord();
        document.getElementsByTagName('body')[0].scrollTop = 0;
    },
    methods: {
        fetchContractInfo(){
            commonService.contractInfo(
                {"contract_id": this.contract_id}
            ).done((rep) => {
                let info = rep.result.data[0];
                this.addr = info.contract_id;
                this.name = info.name;
                this.status = info.status == 0 ? '销毁' : info.status == 1 ? '临时' : info.status == 2 ? '永久' : '';
                this.balance = info.balance || '0';
                this.margin = info.margin || '0';
                this.regTime = info.reg_time;
                this.ownerAddress = info.owner_address;
                this.ownerName = info.owner_name; // 如果有 替代所有者地址
                this.hash = info.hash;
                this.description = info.description;
                this.abis = info.abis;
                this.events = info.events;
            }).fail((rep) => {
                window.error("网络异常，请稍后再试");
            });
        },

        fetchDealRecord(){
            // if(localStorage.contractInfoNum) {
            //     this.pageNo = +localStorage.contractInfoNum;
            // }
            commonService.tradeInfo(
                {"address": this.contract_id, "page": +this.pageNo}
            ).done((rep) => {
                this.pageNum = Math.ceil(rep.result.total / this.pageSize);
                let listArr = rep.result.data;
                listArr.forEach(function (deal, index) {
                    let type = deal.trx_type;
                    listArr[index].trxType =
                        type == 0 ? '普通转账' :
                            type == 1 ? '代理领工资' :
                                type == 2 ? '账户注册' :
                                    type == 3 ? '注册代理' :
                                        type == 4 ? '升级代理' :
                                            type == 5 ? '更新账户' :
                                                type == 10 ? '合约注册' :
                                                    type == 11 ? '合约充值' :
                                                        type == 12 ? '合约升级' :
                                                            type == 13 ? '合约销毁' :
                                                                type == 14 ? '合约调用' :
                                                                    type == 15 ? '合约出账' : '';
                });
                this.dealList = listArr;
            }).fail((rep) => {
                window.error("网络异常，请稍后再试");
            });
        },
        changePage(num){
            // localStorage.contractInfoNum = +pageNo;
            this.pageNo = +num;
            this.fetchDealRecord();
        }
    }
});



// WEBPACK FOOTER //
// ./src/module/contract/contractInfo/main.js